import { Drawer, Stack } from "@mui/material"
import { observer } from "mobx-react-lite"
import appStore from "../../store"

const AppDrawer = observer(() => {

  return (
    <Drawer
      open={appStore.drawerOpen}
      onClose={() => appStore.setDrawerOpen(false)}
    >
      <Stack sx={{ width: 300 }}>

      </Stack>
    </Drawer>
  )
})

export default AppDrawer